export default __webpack_public_path__ + "static/media/waterloo.d4be086e.jpg";